import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '../../helpers/api-helper';
import ExpertiseApi from '../../../infrastructure/expertise-api';
export const getAllExpertisesAsync = createAsyncThunk('expertise/getAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ExpertiseApi.getAllExpertises();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
